import { Box, Button, Tooltip, Typography } from "@mui/material";
import { insuranceActions, insuranceSelector } from "../../../model";
import { useDispatch, useSelector } from "react-redux";
import { useNotifications } from "modules/notification";
import { useMutation } from "@apollo/client";
import { DEACTIVATE_DOC, UPDATE_DOCUMENTS_LENDER_ACCESS } from "../../../api";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { UploadedFileRow } from "./UploadedFileRow";
import { useStepperState } from "modules/vendorOpportunity/insurance/hooks/useStepperState";
import { coverageStatusConfig } from "modules/vendorOpportunity/insurance/constants";
import { CoverageStatusLabels } from "modules/vendorOpportunity/insurance/types";
import { useMemo } from "react";

export const CertificateUploaded = () => {
  const dispatch = useDispatch();

  const selectedSubmission = useSelector(insuranceSelector.selectedSubmission)!;
  const insuranceCertificate = useSelector(insuranceSelector.insuranceCertificate)!;

  const { showNotification } = useNotifications();
  const { stepperUnCompleteVerifyCoverage } = useStepperState();

  const [replaceFile, { loading: replaceFileLoading }] = useMutation(DEACTIVATE_DOC);
  const [updateLenderDocumentsAccess, { loading: sendToLenderLoading }] = useMutation(UPDATE_DOCUMENTS_LENDER_ACCESS);

  const isCertificateSharedWithLender = useMemo(() => {
    const documentCreditSubmission = insuranceCertificate.documentCreditSubmission?.find(
      dcs => dcs?.creditSubmissionId === selectedSubmission?.creditSubmissionId
    );
    return !!documentCreditSubmission?.lenderAccess;
  }, [selectedSubmission, insuranceCertificate]);

  const handleReplaceFile = async () => {
    try {
      await replaceFile({
        variables: {
          id: insuranceCertificate.documentId,
        },
      });
      dispatch(insuranceActions.setInsuranceCertificate(null));
      stepperUnCompleteVerifyCoverage();
      dispatch(insuranceActions.setCoverageStatusConfig(coverageStatusConfig[CoverageStatusLabels.InsuredUnverified]));
    } catch (error) {
      showNotification("Error", { type: "error" });
    }
  };

  const sendToLender = async () => {
    try {
      await updateLenderDocumentsAccess({
        variables: {
          batchUpdateLenderDocumentAccessInput: {
            creditSubmissionId: selectedSubmission.creditSubId,
            documents: [
              {
                documentId: insuranceCertificate.documentId,
                lenderAccess: true,
                dealerAccess: true,
              },
            ],
          },
        },
      });
      dispatch(
        insuranceActions.setInsuranceCertificate({
          ...insuranceCertificate,
          creditSubmissionId: selectedSubmission.creditSubId,
        })
      );
    } catch (error) {
      showNotification("Error", { type: "error" });
    }
  };

  return (
    <>
      <Box mb={2}>
        {isCertificateSharedWithLender ? (
          <Box display="flex">
            <CheckCircleOutlineIcon color="primary" />
            <Typography mb={1} ml={0.5} component="p" variant="body1">
              You have sent the Certificate of Insurance to Lender
            </Typography>
          </Box>
        ) : (
          <Tooltip title="First, choose a submission" placement="top" disableHoverListener={!!selectedSubmission}>
            <span>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={sendToLender}
                loading={sendToLenderLoading}
                sx={{ marginRight: 1 }}
                disabled={!selectedSubmission}>
                Send COI to Lender
              </Button>
            </span>
          </Tooltip>
        )}
        <Button size="small" color="primary" onClick={handleReplaceFile} loading={replaceFileLoading}>
          Replace file
        </Button>
      </Box>
      <UploadedFileRow onRemove={handleReplaceFile} />
    </>
  );
};
